/*
 * Module file for URI-Parser
 *
 * Copyright 2011, Stuart Hudson <goulash1971@yahoo.com>
 * Released under the terms of the MIT License.
 * 
 * Version 1.0.0
 */

module.exports = require("./lib");